import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles(() => ({
  container: {
    margin: "50px 0 0 20px",
    padding: "20px",
    overflow: "visible",
    boxShadow: " 0px 0px 25px 0px rgba(0, 0, 0, 0.1)",
  },
  divider: {
    width: "100%",
    margin: "10px 0px",
    padding: "0",
  },
  loading: {
    display: "grid",
    placeItems: "center",
    margin: "20px auto",
  },
}));
